module.exports = __webpack_public_path__ + "media/price_bot/chatButton-4c9513bc.svg";